import { TooltipWrapper } from "../../components/tooltip/TooltipWrapper";
import styles from "./CompanyInfoHeader.module.css";
import { SafeReportResponse } from "./Conversion";
import { formatAbbreviatedMoney } from "./Money";

type CompanyInfoHeaderProps = {
  specialtyPropertyInfo: SafeReportResponse;
};

export const CompanyInfoHeader: React.FC<CompanyInfoHeaderProps> = ({
  specialtyPropertyInfo,
}) => {
  const industry =
    specialtyPropertyInfo.report_json.company_info.business_description;
  return (
    <div className={styles.companyInfoContainer}>
      {industry && (
        <TooltipWrapper
          tooltipText="Business Description"
          tooltipProps={{ position: "top" }}
        >
          <div className={styles.companyInfoComponentContainer}>
            <i className="pi pi-briefcase" />
            <span>{industry}</span>
          </div>
        </TooltipWrapper>
      )}
      <TooltipWrapper
        tooltipText="Business Code"
        tooltipProps={{ position: "top" }}
      >
        <div className={styles.companyInfoComponentContainer}>
          <i className="pi pi-building" />
          <span>{`${specialtyPropertyInfo.report_json.naics_info.code_type?.toUpperCase()} ${
            specialtyPropertyInfo.report_json.naics_info.code
          }`}</span>
        </div>
      </TooltipWrapper>
      <TooltipWrapper
        tooltipText="Brokerage"
        tooltipProps={{ position: "top" }}
      >
        <div className={styles.companyInfoComponentContainer}>
          <i className="pi pi-user" />
          <span>
            {specialtyPropertyInfo.report_json.company_info.broker_name}
          </span>
        </div>
      </TooltipWrapper>
      {specialtyPropertyInfo.report_json.company_info.effective_date && (
        <TooltipWrapper
          tooltipText="Effective Date"
          tooltipProps={{ position: "top" }}
        >
          <div className={styles.companyInfoComponentContainer}>
            <i className="pi pi-calendar" />
            <span>
              {specialtyPropertyInfo.report_json.company_info.effective_date}
            </span>
          </div>
        </TooltipWrapper>
      )}
      {specialtyPropertyInfo.report_json.company_info.target_premium && (
        <TooltipWrapper
          tooltipText="Target Premium"
          tooltipProps={{ position: "top" }}
        >
          <div className={styles.companyInfoComponentContainer}>
            <i className="pi pi-bullseye" />
            <span>
              {formatAbbreviatedMoney(
                Number(
                  specialtyPropertyInfo.report_json.company_info.target_premium
                )
              )}
            </span>
          </div>
        </TooltipWrapper>
      )}
      {specialtyPropertyInfo.report_json.company_info.quote_by_date && (
        <TooltipWrapper
          tooltipText="Quote By Date"
          tooltipProps={{ position: "top" }}
        >
          <div className={styles.companyInfoComponentContainer}>
            <i className="pi pi-calendar-clock" />
            <span>
              {specialtyPropertyInfo.report_json.company_info.quote_by_date}
            </span>
          </div>
        </TooltipWrapper>
      )}
    </div>
  );
};
